export default __webpack_public_path__ + "static/twitterSummaryX-7bf121db27d67c20c08837de281476ff.jpg";